/* ============================================================
   SPORT ENERGY - FOOTER (Bevel)
   FASE 1.0.0 - 11. juli 2026
   Deploy: assets/sport-energy-footer.js
   Ansvar: (1) mobil-accordion paa link-kolonnerne (<= 920px),
   (2) rul til nyhedsbrevs-feltet efter Shopify-redirect, saa
   succes/fejl-beskeden er synlig (customer_posted / #se-nyt).
   Ingen afhaengigheder. Koerer defensivt: findes footeren ikke,
   goer scriptet ingenting.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var footer = document.querySelector('.se-footer');
    if (!footer) { return; }

    /* ---------- 1) Mobil-accordion ---------- */
    var mq = window.matchMedia('(max-width: 920px)');
    var toggles = footer.querySelectorAll('.sef-acc');

    function setAria() {
      for (var i = 0; i < toggles.length; i++) {
        var kol = toggles[i].parentElement;
        var open = kol.classList.contains('sef-open');
        if (mq.matches) {
          toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
        } else {
          toggles[i].removeAttribute('aria-expanded');
        }
      }
    }

    function onToggle(e) {
      if (!mq.matches) { return; }
      var kol = e.currentTarget.parentElement;
      kol.classList.toggle('sef-open');
      setAria();
    }

    for (var i = 0; i < toggles.length; i++) {
      /* pointerdown for oejeblikkelig respons, click som fallback for tastatur */
      toggles[i].addEventListener('pointerdown', onToggle);
      toggles[i].addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle(e);
        }
      });
    }
    if (mq.addEventListener) { mq.addEventListener('change', setAria); }
    setAria();

    /* ---------- 2) Synlig kvittering efter tilmelding ---------- */
    /* Shopify redirecter tilbage med ?customer_posted=true (succes)
       eller gen-renderer siden med form.errors. I begge tilfaelde
       ligger beskeden i footeren, som brugeren ellers ikke ser.
       Vi ruller kun, naar URL'en baerer signalet. */
    var href = window.location.href;
    var posted = href.indexOf('customer_posted=true') !== -1;
    var anchored = window.location.hash === '#se-nyt';
    if (posted || anchored) {
      var maal = document.getElementById('se-nyt');
      if (maal) {
        window.setTimeout(function () {
          maal.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 150);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();